// Konstanty Přehledu (dlaždice, velikosti, období).
// (Krok B1b: rozděleno ze src/app.js beze změny kódu; importy/exporty doplněny automaticky.)
import { dashboardConfig } from './state.js';

// ---------- konstanty Přehledu (dlaždice, velikosti, období) ----------
var DASHBOARD_KPI_IDS = ['kpiAudits','kpiPass','kpiScore','kpiOpen','kpiPlan','kpiOnTime'];
var DASHBOARD_SECTIONS = DASHBOARD_KPI_IDS.concat(['trend','correctiveStatus','correctiveDiscipline','plan','areas','heatmap','correctiveFlow','correctiveAging','responsible','branches','workplaces','types','failing','auditors']);
var DASHBOARD_SECTION_META = {
  kpiAudits: {label:'Uzavřené audity', hasLimit:false, defSize:'s'},
  kpiPass: {label:'Audity bez závad', hasLimit:false, defSize:'s'},
  kpiScore: {label:'Skóre', hasLimit:false, defSize:'s'},
  kpiOpen: {label:'Otevřená opatření', hasLimit:false, defSize:'s'},
  kpiPlan: {label:'Plnění plánu', hasLimit:false, defSize:'s'},
  kpiOnTime: {label:'Opatření v termínu', hasLimit:false, defSize:'s'},
  trend: {label:'Vývoj kvality', hasLimit:true, limitLabel:'Počet zobrazených měsíců', def:12, limitOptions:[3,6,12,24], defSize:'l'},
  correctiveStatus: {label:'Stav opatření', hasLimit:false, defSize:'m'},
  correctiveDiscipline: {label:'Kázeň v řešení opatření', hasLimit:false, defSize:'m'},
  plan: {label:'Plnění plánu auditů', hasLimit:false, defSize:'m'},
  areas: {label:'Nejslabší oblasti', hasLimit:true, limitLabel:'Počet zobrazených oblastí', def:5, limitOptions:[3,5,10,0], defSize:'m'},
  heatmap: {label:'Mapa pracovišť', hasLimit:true, limitLabel:'Počet zobrazených měsíců', def:6, limitOptions:[3,6,12], defSize:'l'},
  correctiveFlow: {label:'Nová vs. vyřešená opatření', hasLimit:true, limitLabel:'Počet zobrazených měsíců', def:6, limitOptions:[3,6,12], defSize:'m'},
  correctiveAging: {label:'Stáří otevřených opatření', hasLimit:false, defSize:'m'},
  responsible: {label:'Odpovědné osoby', hasLimit:true, limitLabel:'Počet zobrazených osob', def:3, defSize:'m'},
  branches: {label:'Srovnání provozoven', hasLimit:false, defSize:'m'},
  workplaces: {label:'Pracoviště (nejhorší nahoře)', hasLimit:true, limitLabel:'Počet zobrazených pracovišť', def:3, defSize:'m'},
  types: {label:'Podle druhu auditu', hasLimit:true, limitLabel:'Počet zobrazených druhů auditů', def:3, defSize:'m'},
  failing: {label:'Nejčastěji propadající otázky', hasLimit:true, limitLabel:'Počet zobrazených otázek', def:3, defSize:'m'},
  auditors: {label:'Auditoři', hasLimit:true, limitLabel:'Počet zobrazených auditorů', def:3, defSize:'m'}
};
// v2 = nové statistiky, v3 = ukazatele jako samostatné dlaždice (místo
// jedné dlaždice "kpis") a bez dlaždic correctiveOverdue/InProgress.
var DASHBOARD_CONFIG_VERSION = 3;
// Skupiny ukazatelů (vlastní slučování dlaždic): id "grp…", velikost M/L.
var DASHBOARD_GROUP_SIZES = ['m','l'];
function isDashGroupId(id){ return /^grp[a-z0-9]{1,24}$/.test(id||''); }
function dashGroup(id){ return isDashGroupId(id) && dashboardConfig.groups ? dashboardConfig.groups[id] : null; }
// Popis dlaždice (název, omezení počtu) — pro skupinu podle jejího nadpisu.
function dashMeta(id){
  var g = dashGroup(id);
  if(g) return {label: g.title || 'Skupina ukazatelů', hasLimit:false, isGroup:true};
  return DASHBOARD_SECTION_META[id] || {label:id, hasLimit:false};
}
var DASHBOARD_V2_NEW_IDS = ['correctiveStatus','correctiveDiscipline','plan','areas','heatmap','correctiveFlow','correctiveAging','responsible','branches'];
var DASHBOARD_SIZES = ['s','m','l'];
var DASHBOARD_SIZE_LABELS = {s:'S', m:'M', l:'L'};
var DASHBOARD_PERIODS = [
  {id:'all', label:'Vše'},
  {id:'month', label:'Tento měsíc'},
  {id:'quarter', label:'Tento kvartál'},
  {id:'year', label:'Tento rok'},
  {id:'last12m', label:'Posledních 12 měsíců'},
  {id:'fiscal', label:'Tento fiskální rok'},
  {id:'lastFiscal', label:'Minulý fiskální rok'},
  {id:'custom', label:'Vlastní období…'}
];

export {
  DASHBOARD_CONFIG_VERSION,
  DASHBOARD_GROUP_SIZES,
  DASHBOARD_KPI_IDS,
  DASHBOARD_PERIODS,
  DASHBOARD_SECTIONS,
  DASHBOARD_SECTION_META,
  DASHBOARD_SIZES,
  DASHBOARD_SIZE_LABELS,
  DASHBOARD_V2_NEW_IDS,
  dashGroup,
  dashMeta,
  isDashGroupId
};
